import { AdminPageShell } from "../components/index.js";
import { ReportsList } from "../features/reports/index.js";
import { useT } from "../i18n/index.js";

export function ReportsListPage() {
  const t = useT();
  return (
    <AdminPageShell crumbs={[{ label: t("admin.reports") }]}>
      <ReportsList />
    </AdminPageShell>
  );
}
